export const GLOBAL_STATE = 'Staff'

export const STAFF = 'STAFF' as const
export const STAFF_DELETE = 'STAFF_DELETE' as const
export const STAFF_LIST = 'STAFF_LIST' as const
export const STAFF_ALL = 'STAFF_ALL' as const
export const STAFF_ALL_FILTERED = 'STAFF_ALL_FILTERED' as const
export const STAFF_PERSONAL_INFO = 'STAFF_PERSONAL_INFO' as const
export const STAFF_FULL_INFO_UPDATE = 'STAFF_FULL_INFO_UPDATE' as const
export const STAFF_FULL_INFO = 'STAFF_FULL_INFO' as const
export const STAFF_HR_INFO_UPDATE = 'STAFF_HR_INFO_UPDATE' as const
export const STAFF_HR_INFO = 'STAFF_HR_INFO' as const
export const STAFF_USERNAME = 'STAFF_USERNAME' as const
export const STAFF_DEPARTMENT_POSITION = 'STAFF_DEPARTMENT_POSITION' as const
export const STAFF_PROOF_OF_WORK_PDF = 'STAFF_PROOF_OF_WORK_PDF' as const
export const PUBLIC_STAFF_REF = 'PUBLIC_STAFF_REF' as const
